import css from './langIcon.module.scss';

import { memo } from 'react';

import { LANGUAGES_DATA } from 'core/helpers/languages';

const LangIcon: React.FC<{ lang: TLang; className?: string }> = ({
  lang,
  className = '',
}) => {
  const Icon = LANGUAGES_DATA[lang].icon;
  return (
    <span className={`${css.icon} ${className}`}>
      <Icon />
    </span>
  );
};

export default memo(LangIcon);
